import React from "react";
import {Text, View, Box} from "@unibuddy/patron";
import {AttachmentField} from "src/types/generated";

import {rootURL} from "shared/Utils/WhereAmI";
import {ThemedLink} from "../../../components/ThemedLink/ThemedLink";

const enum TemplateType {
    INFO = "info",
    LINK = "link",
}

const InfoText = ({text}: {text: string}) => (
    <Box marginY="xsmall">
        <Text size="small" color="grey700" align="center">
            {text}
        </Text>
    </Box>
);

const LinkToChat = ({text, path}: {text: string; path: string}) => {
    const baseUrl = rootURL(location.pathname);
    return (
        <Text size="small">
            <ThemedLink aria-label={text} to={`${baseUrl}/inbox/${path}`}>
                {text}
            </ThemedLink>
        </Text>
    );
};

export const TransferChat = ({attachment}: {attachment: AttachmentField}) => {
    if (!attachment?.payload) return null;

    const {templateType, text, relativePath} = attachment.payload;

    return (
        // Parent should be a list
        <View alignItems="center" role="listitem">
            {templateType === TemplateType.INFO && <InfoText text={text} />}
            {templateType === TemplateType.LINK && (
                <LinkToChat text={text} path={relativePath.replace("./", "")} />
            )}
        </View>
    );
};
